import React from "react";
import FieldCheckboxComponent from "../../FieldCheckbox/FieldCheckbox";
import { FLAT_RATE, PERCENTAGE_OF_RENTAL } from "../../../util/constants";
import css from './FeesInputFields.module.css';
import { formatMoney } from "../../../util/currency";

const OtherOptionalChargesField = (props) => {
    const { otherOptionalCharges, intl, fetchLineItemsInProgress  } = props;
  
    if(!otherOptionalCharges || !otherOptionalCharges?.length){
      return null;
    }
  
    return (
      <div className={css.otherFeesContainer}>
        <h5 className={css.title}>{intl.formatMessage({id:"OtherOptionalChargesField.OtherOptionalFees.title"})}</h5>
        {otherOptionalCharges.map((fee) => (
          <div className={css.otherFee}>
            <div>
              <FieldCheckboxComponent
                id={fee.feeType}
                name="otherOptionalFees"
                label={intl.formatMessage({
                  id: "OtherOptionalChargesField.OtherOptionalFees.label"
                }, { feeType: fee.feeType }
                )}
                value={fee.feeType}
                autoFocus={true}
                disabled={fetchLineItemsInProgress}
              />
              <span className={css.feeDescription}>{fee.feeDescription}</span>
            </div>
            <span>
              {fee.feeCalculationType === FLAT_RATE
                ? formatMoney(intl, fee.rate)
                : fee.feeCalculationType === PERCENTAGE_OF_RENTAL
                  ? intl.formatMessage({ id: "OtherOptionalChargesField.OtherOptionalFees.percentage" }, { percentage: fee.percentage })
                  : null}
            </span>
          </div>
        ))}
      </div>
    )
  }

  export default OtherOptionalChargesField;